import { themeGet } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const userAvatar = css `
  .ck-user__name {
    font-weight: ${themeGet('fontWeight.medium')};
  }
`;
